<template>
  <div class="bgfff out_wrap">
    <UseGuide class="mb20">
      <div>1.每天12:30生成昨日资金流水压缩包。</div>
      <div>2.每日压缩包导出后解压，重命名文件添加文件后缀名.csv后方可excel打开。</div>
    </UseGuide>
    <div class="between search">
      <div class="left flex1">
        <el-form label-width="82px" :model="form" label-suffix=":">
          <div class="form-box">
            <el-form-item label="支付时间" class="formItem">
              <el-date-picker
                v-model="form.time"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                :clearable="false"
                end-placeholder="结束日期"
                :editable="false"
                :value-format="'yyyy-MM-dd'"
                unlink-panels
                :picker-options="pickerOptions"
                @change="query"
              />
            </el-form-item>
            <el-form-item label="签约主体" class="formItem">
              <el-select v-model="form.channel_id" placeholder="请选择">
                <el-option label="全部" value="" />
                <el-option v-for="item in channelArr" :key="item.channel_id" :label="item.channel_name" :value="item.channel_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="交易类型" class="formItem">
              <el-select v-model="form.mch_type" placeholder="请选择交易类型">
                <el-option label="全部" value="" />
                <el-option v-for="item in channelType" :key="item.id" :label="item.lable" :value="item.id" />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="flex_end mr24">
      <div class="right">
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
        <el-button type="primary" @click="exportData">导出</el-button>
        <el-button type="primary" @click="exportDataAll">压缩包导出</el-button>
      </div>
    </div>
    <div class="total_box flex mb22 mt20">
      <div class="mr20">总消耗：<span class="active_color">￥{{ $formatCurrency(info.consum_price) || '0.00' }}</span></div>
      <div class="mr20">预扣增值税：<span class="active_color">￥{{ $formatCurrency(info.vat_amount) || '0.00' }}</span></div>
      <div class="mr20">预扣附加税：<span class="active_color">￥{{ $formatCurrency(info.super_amount) || '0.00' }}</span></div>
      <div class="mr20">预扣个税：<span class="active_color">￥{{ $formatCurrency(info.iit_amount) || '0.00' }}</span></div>
      <div class="mr20">总服务费：<span class="active_color">￥{{ $formatCurrency(info.service_price) || '0.00' }}</span></div>
      <div class="mr20">总充值：<span class="active_color">￥{{ $formatCurrency(info.recharge_price) || '0.00' }}</span></div>
    </div>
    <zf-table
      :columns="column"
      :data-source="list"
      :pagination="false"
    >
      <!-- 总消耗 -->
      <template slot="consum_price" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.consum_price) }}
      </template>
      <!-- 预扣增值税 -->
      <template slot="vat_amount" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.vat_amount) }}
      </template>
      <!-- 预扣附加税 -->
      <template slot="super_amount" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.super_amount) }}
      </template>
      <!-- 预扣个税 -->
      <template slot="iit_amount" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.iit_amount) }}
      </template>
      <!-- 总结算中 -->
      <template slot="pending_price" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.pending_price) }}
      </template>
      <!-- 服务费 -->
      <template slot="service_price" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.service_price) }}
      </template>
      <!-- 总充值 -->
      <template slot="recharge_price" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.recharge_price) }}
      </template>
      <!-- 可用余额 -->
      <template slot="use_price" slot-scope="{ row }">
        ￥{{ $formatCurrency(row.use_price) }}
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a class="active_color" title="每日压缩包导出" @click="download(row)">每日压缩包导出</a>
      </template>
    </zf-table>
  </div>
</template>

<script>
import column from './columns/moneyWater'
import dayjs from 'dayjs'
import ZfTable from '@/components/ZfTable/CoreTable'
import UseGuide from '@/components/UseGuide'
import { capitalList, capitalListout, orderCompress, download } from '@/api/refund'
import { billDownload } from '@/api/pay'
import { channelList } from '@/api/accountInfo'
import exportFiles from '@/utils/exportFile'
export default {
  name: 'List',
  components: {
    ZfTable,
    UseGuide
  },
  data() {
    return {
      column,
      form: {
        channel_id: '', // 签约主体
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        mch_type: ''
      },
      list: [],
      info: {},
      channelArr: [],
      channelType: [
        {
          lable: '微信',
          id: '1'
        },
        {
          lable: '支付宝',
          id: '2'
        }
      ]
    }
  },
  mounted() {
    this.query()
    channelList().then(res => {
      this.channelArr = res.data
    })
  },
  methods: {
    async query() {
      const res = await capitalList({ ...this.form, start_day: this.form.time[0], end_day: this.form.time[1] })
      if (res.code === 200) {
        this.list = res.data.list
        this.info = res.data.total
      }
    },
    resetForm() {
      this.form = {
        channel_id: '',
        mch_type: '',
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      }
      this.query()
    },
    async exportData() {
      // 导出
      const params = {}
      if (this.form.time && this.form.time.length) {
        params.start_day = this.form.time[0]
        params.end_day = this.form.time[1]
        params.channel_id = this.form.channel_id
        params.mch_type = this.form.mch_type
      } else {
        params.start_day = ''
        params.end_day = ''
        params.channel_id = this.form.channel_id
        params.mch_type = this.form.mch_type
      }
      const res = await capitalListout(params)
      if (res.type !== 'application/json') {
        exportFiles(res, '资金流水')
      }
    },
    exportDataAll() {
      const start_month = dayjs(this.form.time[0]).format('YYYYMM')
      const end_month = dayjs(this.form.time[1]).format('YYYYMM')
      if (start_month !== end_month) {
        this.$message('支付时间需在同一个月')
        return
      }
      orderCompress({ start_day: this.form.time[0], end_day: this.form.time[1] }).then(res => {
        if (res.code === 200) {
          download({ download_id: res.data.download_id }).then(data => {
            if (data.type !== 'application/json') {
              const blob = new Blob([data], { type: 'application/zip' })
              const url = window.URL.createObjectURL(blob)
              const link = document.createElement('a') // 创建a标签
              link.href = url
              link.download = `${this.form.time[0]}${'~'}${this.form.time[1]}${'资金流水.zip'}`
              document.body.appendChild(link)
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          })
        }
      })
    },
    async download(row) {
      const query_date = dayjs(row.day).format('YYYYMMDD')
      const res = await billDownload({ bill_date: query_date })
      if (res.type !== 'application/json') {
        const blob = new Blob([res], { type: 'application/gz' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a') // 创建a标签
        link.href = url
        link.download = `${row.day}${'资金流水.gz'}`
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(url) // 释放内存
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
